import { Betriebsstoerung, Fachbefund, gemeldet, KennwortNoetig, Nichtangemeldet, Rechenabbruch } from './api'
import { satz, t } from './sprache'

/**
 * **Was eine Seite selbst zu einem Fehler sagt — nur das Fachliche** (7.2
 * Abschnitt 30, R1003, R1004).
 *
 * Ein fachlicher Fehler steht am Ort, mit dem Satz des Dienstes: ein Befund
 * des Rechenkerns samt Weg, ein Feldfehler. Ein technischer steht im
 * Störungsfenster, und die Seite sagt dazu nichts — sie bekommt `null`.
 *
 * **Der Befund vom 2026-10-03:** Auf der Kursseite stand für jeden Fehler
 * „Das ließ sich nicht schreiben.", und mehrere Seiten verschluckten so auch
 * fachliche Befunde unter einem Sammelsatz. Diese Stelle ersetzt die
 * Sammelsätze.
 *
 * **Was weder das eine noch das andere ist** — ein Programmfehler in der
 * Oberfläche selbst — gilt als technisch und wird hier gemeldet: Ohne die
 * Meldung stünde der Anwender vor einer Seite, die nichts tat und nichts sagt.
 */
export function fachlicherSatz(f: unknown): string | null {
  if (f instanceof Rechenabbruch) {
    return [satz(f.meldung), f.handreichung ? satz(f.handreichung) : ''].filter(Boolean).join(' ')
  }

  if (f instanceof Fachbefund) {
    return t(f.schluessel)
  }

  // Die abgelaufene Sitzung beantwortet die Anmeldung, nicht ein Satz.
  if (f instanceof Betriebsstoerung || f instanceof Nichtangemeldet || f instanceof KennwortNoetig) {
    return null
  }

  gemeldet(new Betriebsstoerung('meldung.stoerung.unbekannt'))
  return null
}
